import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	componentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	componentLabel: {
		id: 'issue-field-components-field.edit.menu.component-label',
		defaultMessage: 'Create new component',
		description: 'Component label. Allows to create new components from dropdown link.',
	},
});
export default messages;
